// src/hooks/useEcommerce.js
import { useCallback, useState } from "react";
import { useData } from "./useData";

export const useEcommerce = () => {
  const {
    canvas,
    basketItem,
    setBasketItem,
    setSnackbar,
    setLoading,
    setError,
    signCategories,
  } = useData();

  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const vinylAddToBasket = useCallback(
    async (jsonBasket) => {
      if (!canvas || !basketItem.productCode) {
        setSnackbar({
          open: true,
          message: "Please create a design and select a product.",
          severity: "error",
        });
        return;
      }

      if (isAddingToCart) return;

      setIsAddingToCart(true);
      setLoading(true);

      try {
        const mivaObj = jsonBasket;
        if (!mivaObj.session_id) {
          throw new Error("Miva globals missing session_id.");
        }

        const ajaxBasketUrl = `https://www.alphabetsigns.com/mm5/merchant.mvc?Screen=AJXATC&t=${Date.now()}`;
        const response = await fetch(ajaxBasketUrl, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(jsonBasket),
        });

        if (!response.ok)
          throw new Error(`Basket API failed: ${response.status}`);

        const basketData = await response.json();

        // Update pricing...
        if (basketItem.productCode && basketData.response_update_price) {
          const jsonUpdateBasket = {
            function: "BasketItem_Update_Pricing",
            update_price: Number(basketData.response_update_price || 0).toFixed(
              8
            ),
            basket_id: basketData.basket_id,
            product_code: basketData.product_code,
            session_id: basketData.session_id,
          };

          const ajaxUpdateUrl = `https://www.alphabetsigns.com/mm5/merchant.mvc?Screen=AJXUPC&t=${Date.now()}`;
          const updateResponse = await fetch(ajaxUpdateUrl, {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(jsonUpdateBasket),
          });

          if (!updateResponse.ok)
            throw new Error(`Pricing update failed: ${updateResponse.status}`);
          await updateResponse.json();
        }

        setSnackbar({
          open: true,
          message: "Product added to cart successfully!",
          severity: "success",
        });
      } catch (error) {
        console.error("[vinylAddToBasket]:Error ", error);
        setError("E-commerce error: " + error.message);
        setSnackbar({
          open: true,
          message: error.message || "Failed to add to cart.",
          severity: "error",
        });
      } finally {
        setIsAddingToCart(false);
        setLoading(false);
      }
    },
    [canvas, basketItem, setSnackbar, setLoading, setError, isAddingToCart]
  );

  return {
    vinylAddToBasket,
    isAddingToCart,
  };
};
